import {
  Box,
  Table,
  Text,
} from "@chakra-ui/react";
import { useId } from "react";
import { formatNumber } from "../../../store/helpers";

const ArrivalRatesPerDayTable = ({ average, min, max, total, title }) => {
  const id = useId();


  return (
    <Box mt={10}>
      <h3>{title}</h3>
      <Box>
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Visitors</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader>Max</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row key={id}>
              <Table.Cell>1</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0" color={"var(--darkGray)"}>
                {formatNumber(total)}
              </Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">
                <Text color={"var(--blue)"}>{formatNumber(average)}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text color={"var(--blue)"}>{formatNumber(min)}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text color={"var(--blue)"}>{formatNumber(max)}</Text>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      </Box>
    </Box>
  );
};

export default ArrivalRatesPerDayTable;
